<template>
    <div>
        <payment-methods-table :paymentMethods="paymentMethods" :loading="loading" class="mb-4" @reloadPaymentMethods="getPaymentMethods"/>
    </div>
</template>

<script>
import paymentMethodsTable from "./paymentMethodsTable.vue";
import moment from "moment";
export default {
    components: {
        paymentMethodsTable
    },
    data() {
        return {
            paymentMethods: [],
            loading: true
        };
    },
    created() {
        this.getPaymentMethods()
    },
    methods:{
        getPaymentMethods(){
            this.$axios
            .get("api/orders/getPaymentMethods")
            .then(axRes => {
                this.loading = false;
                this.paymentMethods = axRes.data;
                moment.locale("it");
                for (var i in this.paymentMethods) {
                    try {
                        this.paymentMethods[i].fee = this.paymentMethods[i].fee
                            ? this.$formatPrice(this.paymentMethods[i].fee)
                            : "nessuna tassa";
                    } catch (e) {
                        console.log(e);
                    }
                }
            })
            .catch(axErr => {
                this.showToast(this.$t("system.genericError"), {
                    icon: "fa-warning",
                    position: "bottom-right",
                    duration: 10000,
                    fullWidth: false,
                    className: "vuestic-toast error"
                });
                this.loading = false;
            });
        }
    }
};
</script>
